if( ! document.getElementById('filter-job-location-typing') ) {
    return;
}

document.getElementById('filter-job-location-typing').addEventListener('keyup', function () {
    const locationTyping = this.value.trim();
    const autocompleteLocationBox = document.getElementById('filter-job-location-autocomplete');
    const radius = document.getElementById('filter-job-radius')?.value || '';

    if (locationTyping.length > 1) {
        const jobFilterFetchUrl = ajax_callback_data.ajax_url + '?action=filter_jobs&location=' + encodeURIComponent(locationTyping) + '&radius=' + encodeURIComponent(radius);
        fetch(jobFilterFetchUrl)
            .then(response => response.json())
            .then(data => {
                if (data.length > 0) {
                    autocompleteLocationBox.innerHTML = `<div class="filter-autocomplete">
                        ${data
                            .map(item => `<div class="autocomplete-item" data-title="${item}">${item}</div>`)
                            .join('')}
                    </div>`;
                    autocompleteLocationBox.style.display = 'block';

                    // Attach click event to newly added items
                    document.querySelectorAll('.autocomplete-item').forEach(item => {
                        item.addEventListener('click', function () {
                            document.getElementById('filter-job-location-typing').value = this.dataset.title;
                            autocompleteLocationBox.style.display = 'none';
                        });
                    });
                } else {
                    autocompleteLocationBox.innerHTML = '<div class="filter-autocomplete no-results">No results found</div>';
                }
            })
            .catch(error => console.error('Error fetching data:', error));
    } else {
        autocompleteLocationBox.style.display = 'none';
    }
});

// Hide autocomplete when clicking outside
document.addEventListener('click', function (e) {
    const inputLocationBox = document.getElementById('filter-job-location-typing');
    const autocompleteLocationBox = document.getElementById('filter-job-location-autocomplete');
    
    if (!inputLocationBox.contains(e.target) && !autocompleteLocationBox.contains(e.target)) {
        autocompleteLocationBox.style.display = 'none';
    }
});